import { Capacitor } from '@capacitor/core';

export const isWeb = () => {
  return !Capacitor.isNativePlatform();
};

export const isIOS = () => {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
};
